<div class="timer-configs-container">
  <wr-banner [icon]="{ icon: 'info-outline', pack: 'eva' }"
             status="info"
             message="Diese Werte werden beim Anlegen eines Wartungstimers für TGAs dieses Bauplans vorgeschlagen. Dienstleister übernehmen die Werte konfigurierter Arten unverändert. Nicht konfigurierte Arten legen Dienstleister frei an.">
  </wr-banner>

  <div class="timer-configs-list" [nbSpinner]="!loaded()">
    @if (loaded()) {
      @for (row of rows(); track row.timerType; let i = $index) {
        <div class="timer-config-row" [class.inactive]="!row.active" [attr.data-timer-type]="row.timerType">
          <div class="row-header">
            <nb-checkbox [checked]="row.active"
                         [disabled]="!isEditing()"
                         (checkedChange)="updateRow(i, { active: $event })">
              <strong>{{ row.timerType | maintenanceTimerType }}</strong>
            </nb-checkbox>
          </div>
          @if (row.active) {
            <div class="row-fields">
              <hau-form-field label="Dauer (Tage)">
                <input nbInput type="number" min="1" fullWidth
                       name="durationDays"
                       [disabled]="!isEditing()"
                       [ngModel]="row.durationDays"
                       (ngModelChange)="updateRow(i, { durationDays: $event })"/>
              </hau-form-field>
              <hau-form-field label="Erinnerung (Tage vorher)">
                <input nbInput type="number" min="0" fullWidth
                       name="reminderDurationDays"
                       [disabled]="!isEditing()"
                       [ngModel]="row.reminderDurationDays"
                       (ngModelChange)="updateRow(i, { reminderDurationDays: $event })"/>
              </hau-form-field>
              <hau-form-field label="Tage vor Termin">
                <input nbInput type="number" min="0" fullWidth
                       name="earlyToleranceDays"
                       [disabled]="!isEditing()"
                       [ngModel]="row.earlyToleranceDays"
                       (ngModelChange)="updateRow(i, { earlyToleranceDays: $event })"/>
              </hau-form-field>
              <hau-form-field label="Tage nach Termin">
                <input nbInput type="number" min="0" fullWidth
                       name="lateToleranceDays"
                       [disabled]="!isEditing()"
                       [ngModel]="row.lateToleranceDays"
                       (ngModelChange)="updateRow(i, { lateToleranceDays: $event })"/>
              </hau-form-field>
              <nb-checkbox class="images-mandatory"
                           [checked]="row.imagesMandatory"
                           [disabled]="!isEditing()"
                           (checkedChange)="updateRow(i, { imagesMandatory: $event })">
                Dienstleister verpflichten (mind. ein Bild beim Abschließen)
              </nb-checkbox>
            </div>
          } @else {
            <p class="empty-hint">
              @if (row.timerType === warrantyType) {
                Keine Konfiguration – Gewährleistungstimer legen nur interne Mandanten an.
              } @else {
                Keine Konfiguration – Dienstleister legen diese Art frei an.
              }
            </p>
          }
        </div>
      }
    }
  </div>
</div>
